import React from "react";
import "../../styles/team.css";

const Team = () => {
  return (
    <section className="team s2" id="team">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12">
            {/* <div className="block-text center">
              <h6 className="sub-heading">
                <span>Artist</span>
              </h6>
              <h3 className="heading wow" data-splitting>
                Our Amazing Team
                <br />
                Members
              </h3>
            </div> */}
          </div>

          <div className="col-12">
            <div className="team-content-wrapper">
              <div className="content">
                <a
                  href="https://www.instagram.com/hee_quoc/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="h5 name"
                >
                  Artist
                </a>
                <p className="postion">
                  Every CVMech is hand-drawn by Hy, the CVPad artist who helped
                  shape our visual style. With more than 100 hours of work put
                  into the collection, each NFT shows a modern robot mascot
                  filled with human emotions and seasonal themes.
                </p>
              </div>
            </div>
          </div>
          <div className="col-xl-6 col-md-8 col-12">
            <div className="team-box team-box-single">
              <div className="image">
                <a
                  href="https://www.instagram.com/hee_quoc/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src="/images/artist.jpeg" alt="Artist" />
                </a>

                <ul className="list-social">
                  <li>
                    <a
                      href="https://www.instagram.com/hee_quoc/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span className="icon-plan"></span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Team;
